import * as Sentry from '@sentry/vue';
import { createChatWoot } from '@productdevbook/chatwoot/vue';

let chatwootReady = false;
window.addEventListener(
    'chatwoot:ready',
    () => {
        chatwootReady = true;
    },
    { once: true }
);

function openChatWindow() {
    window.$chatwoot.toggleBubbleVisibility('show');
    window.$chatwoot.toggle('open');
}

window.showChatWindow = () => {
    if (chatwootReady) {
        openChatWindow();
    } else {
        window.addEventListener('chatwoot:ready', openChatWindow, { once: true });
    }
};

window.vueAppSetupHook = function (app) {
    Sentry.init({
        app,
        dsn: 'https://c95649f412f37695c36b6986bb563652@o4507102829543424.ingest.de.sentry.io/4507136228393040',

        ignoreErrors: [/^Failed to handle API request$/],
    });

    const chatwoot = createChatWoot({
        init: {
            websiteToken: 'vBxLnASupJVBVzy7e36BsDRA',
            baseUrl: 'https://chat.solid-services.eu',
        },
        settings: {
            locale: 'en',
            position: 'right',
            launcherTitle: 'Feedback',
            hideMessageBubble: true,
        },
        partytown: false,
    });
    app.use(chatwoot);
};
